/*
* @Author: MiheevAV
* @Date:   2020-05-19 11:25:37
* @Last Modified by:   MiheevAV
* @Last Modified time: 2020-07-08 16:49:21
*/

require ('bootstrap');
require ('bootstrap-select');
require('bootstrap-select/js/i18n/defaults-ru_RU.js');
window.$ = window.jQuery = require('jquery');

import './js/airports.js';
import './js/requests.js?1';
import './js/tech.js';
import './js/svedeniya.js?1';
import './sass/style.scss';






